import { render } from "./Administrative.vue?vue&type=template&id=6866f21e"
import script from "./Administrative.vue?vue&type=script&lang=js"
export * from "./Administrative.vue?vue&type=script&lang=js"

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__